import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CopyToClipboardComponent } from './copy-to-clipboard.component';
import { MatTooltipModule } from '@angular/material/tooltip';
import { CustomTooltipModule } from '../custom-tooltip/custom-tooltip.module';

@NgModule({
  imports: [CommonModule, MatTooltipModule, CustomTooltipModule],
  declarations: [CopyToClipboardComponent],
  exports: [CopyToClipboardComponent],
})
export class CopyToClipboardModule {}
